module.exports = __webpack_public_path__ + "static/media/Logo.06901649.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Logo.png
// module id = 427
// module chunks = 0